export const StatementData = [
  {
    id:"1",
    OrderID: "#ORD01",
    Course: "InformationAboutUI/UXDesignDegree",
    Date: "22Aug2025",
    Amount: "$160",
    PaymentMethod: "Paypal",
    Status: "Completed",
  },
  {
    id:"2",
    OrderID: "#ORD009",
    Course: "BuildResponsiveRealWorldWebsiteswithCrashCourse",
    Date: "10Aug2025",
    Amount: "$180",
    PaymentMethod: "BankTransfer",
    Status: "Pending",

  },
  {
    id:"3",
    OrderID: "#ORD008",
    Course: "C#DevelopersDoubleYourCodingwithVisualStudio",
    Date: "26Jul2025",
    Amount: "$200",
    PaymentMethod: "Stripe",
    Status: "Completed",

  },
  {
    id:"4",
    OrderID: "#ORD007",
    Course: "WordpressforBeginners-MasterWordpressQuickly",
    Date: "12Jul2025",
    Amount: "$220",
    PaymentMethod: "Paypal",
    Status: "Completed",
  },
  {
    id:"5",
    OrderID: "#ORD006",
    Course: "IntroductiontoPythonProgramming",
    Date: "02Jul2025",
    Amount: "$170",
    PaymentMethod: "Stripe",
    Status: "Completed",

  },
  {
    id:"6",
    OrderID: "#ORD005",
    Course: "LearnJavaScriptandExpresstobecomeaExpert",
    Date: "25Jun2025",
    Amount: "$150",
    PaymentMethod: "BankTransfer",
    Status: "Completed",
  },
];
